
// ReSharper disable InconsistentNaming
define('coach/cumulative/view/views/cumulative-stats-view',['jquery',
        '_',
        'backbone',
        'backbone.marionette',
        './game-chooser-view',
        'smooth-modal',
        'lib/kickoff/svg-replacer',
        'actionclick',
        'model',
        'services',
        'usage-log-event'
    ],
    function ($, _, Backbone, Marionette,
        GameChooserDialogView, SmoothModal, svgReplacer, actionClick, model, services, UsageLogEvent) {
        'use strict';

        var CumulativeStatsView = Marionette.LayoutView.extend({
            events: {
                'actionclick .notifications-area span.icon-close': '_renderNotification',
                'actionclick .game-chooser': '_gameChooserClicked',
                'actionclick .admin-dialog': '_adminDialogClicked',
                'actionclick .stat-clip': '_logClipView'
            },
            modelEvents: {
                'closeDialog': '_closeDialog',
            },
            regions: {
                dialogRegion: SmoothModal
            },
            initialize: function (options) {

            },
            onRender: function () {
            },
            _closeDialog: function() {
                this.dialogRegion.close();
            },
            log: function(logData) {
                this.usageLog = new UsageLogEvent({
                    logger: 'CumulativeStatisticsCoachUsage'
                });
                this.usageLog.log(logData);
            },
            _gameChooserClicked: function() {
                this.dialogRegion.show(new GameChooserDialogView({ model: this.model }));
            },
            _logClipView: function (e) {
                var element = e.target;
                var jqueryElement = $(element);
                var clips = jqueryElement.data('clips');
                var data = {
                    clipIds: clips
                };
                var self = this;

                var userRole = this.model.get('isAthlete') ? 'Athlete/Participant' : 'Administrator/Coach';

                services('cacheClipsForViewing').post(data).done(function (results) {                  
                    var statType = jqueryElement.attr('data-clip-type');
                    var logData = {
                        statType: statType,
                        role: userRole
                    };

                    self.usageLog = new UsageLogEvent({
                        logger: 'CumulativeStatisticsVideo'
                    });
                    self.usageLog.log(logData);

                    window.open(jqueryElement.attr('href'), '_blank');
                });
            }

        });

        return CumulativeStatsView;
    });
